import React from "react";
import "../../style/main.scss";
import Button from "../shared/button";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the Quill styles
import { useState, useEffect } from "react";
import axios from "axios";
import parse from "html-react-parser";
import { toast } from "react-toastify";
import { auth } from "../../config";

const Projects = ({ setUserData, userData, sections, setSections, isFetched }) => {
    const [editorHtml, setEditorHtml] = useState("");
    const [first, setfirst] = useState(false);
    const [totalExperience, setTotalExperience] = useState([]);
    const [isschoolName, setIsschoolName] = useState(false);
    const [newArrayMade, setNewArrayMade] = useState(false);
    const [already, setAlready] = useState(false);
    const [currentActiveIndex, setCurrentActiveIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (userData?.projects) {
            userData?.projects?.map((item, i) => {
                setTotalExperience(prev => [...prev, 1]);
            })
        }
    }, [isFetched])
    const handleChange = (html) => {
        setEditorHtml(html);
    };
    const handleInfoChange = (e, index = currentActiveIndex) => {
        // console.log(e.target.name);
        // console.log(e.target.value);
        // console.log(index)
        if (index == totalExperience.length) {
            setNewArrayMade(true);
        }

        if (e.target.name == "projectName" && e.target.value == "") {
            setIsschoolName(false);
        }
        if (e.target.name == "projectName" && e.target.value != "") {
            setIsschoolName(true);
        }

        // setUserData((prev) => ({
        //   ...prev,
        //   projects: { ...prev?.projects, [e.target.name]: e.target.value },
        // }));

        let temp = userData.projects == undefined ? [] : userData.projects;
        temp[index] = { ...temp[index], [e.target.name]: e.target.value }
        setUserData((prev) => ({ ...prev, projects: temp }))


    };
    const handleQuilChange = (value, index = currentActiveIndex) => {

        // console.log(value);
        // console.log(index);
        if (index == totalExperience.length) {
            setNewArrayMade(true);
        }


        // setUserData((prev) => ({
        //   ...prev,
        //   projects: { ...prev?.projects, description: value },
        // }));

        let temp = userData.projects == undefined ? [] : userData.projects;
        temp[index] = { ...temp[index], description: value }
        setUserData((prev) => ({ ...prev, projects: temp }))
    };



    const handleExp = async (index) => {
        setfirst(!first);
        // console.log("here", index)

        if (newArrayMade) {
            if (userData?.projects) {
                let a = userData.projects;
                a.pop();
                setUserData(prev => ({ ...prev, projects: a }));
                setNewArrayMade(false);

            }
        }
        setCurrentActiveIndex(index);
    };



    const handleAddMore = async () => {

        if (userData.projects ? userData.projects[currentActiveIndex] : false) {
            if (userData.projects[currentActiveIndex].projectName != undefined && userData.projects[currentActiveIndex].projectName != "") {
                setTotalExperience(prev => [...prev, 1]);
                setIsschoolName(false)
                setfirst(!first)
                setNewArrayMade(false);
            }
            else {
                toast("Please Enter Project Name");
            }

        }
        else {
            toast("Please fill some data first")
        }



    };
    const handleDelete = () => {

        if (userData.projects ? userData.projects[currentActiveIndex] : false) {

            if (!newArrayMade) {
                let temp = userData.projects;
                temp.splice(currentActiveIndex, 1);
                setUserData(prev => ({ ...prev, projects: temp }));
                setIsschoolName(false)
                setfirst(!first)
                setNewArrayMade(false);
                if (currentActiveIndex != totalExperience.length) {
                    let t = totalExperience;
                    t.pop();
                    setTotalExperience(t)
                }
            }
            else {

                handleExp(null)
            }
        }
        else {

            handleExp(null)
        }


    }

    const handleAIWriter = async () => {
        if (userData?.projects && userData?.projects[currentActiveIndex] && userData?.projects[currentActiveIndex].description && userData?.projects[currentActiveIndex].description.length > 29 && userData?.projects[currentActiveIndex].projectName) {
            let tempData = { description: parse(userData?.projects[currentActiveIndex].description).props.children, name: userData.projects[currentActiveIndex].projectName }
            // console.log(tempData);

            if (Array.isArray(tempData.description)) {
                let newString = "";
                tempData.description.map((item) => {
                    newString = newString + " " + item.props.children;
                });
                tempData = { description: newString }
            }

            let tempIndex = currentActiveIndex;
            try {
                const tokenId = await auth.currentUser.getIdToken();
                const config = {
                    headers: { Authorization: `Bearer ${tokenId}` }
                };
                setLoading(true);
                // const result = await axios.post("http://localhost:8080/generateProjectDescription", tempData);
                const result = await axios.post("https://resume-ai-nodejs.onrender.com/generateProjectDescription", tempData, config);
                // console.log(result.data);

                let temp = userData.projects == undefined ? [] : userData.projects;
                temp[tempIndex] = { ...temp[tempIndex], description: result.data.description }
                setUserData((prev) => ({ ...prev, projects: temp }))

                setLoading(false);
            }
            catch (e) {
                console.error(e.message)
                setLoading(false);
            }
        }
        else {
            alert("Please Provide some details first to generate summary");
        }
    }

    // Only to check value of totalExperience during development.
    useEffect(() => {
        // console.log(totalExperience);
        // console.log("Current Active Index", currentActiveIndex);
    }, [totalExperience, currentActiveIndex])

    return (
        <div>
            {" "}
            <div className="bahr v-center h-center ">
                <div className="strength w-100">
                    <div className="top" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <p className="text-purple" style={{ margin: "0" }}>Projects</p>
                        <div style={{ width: "15px", height: "15px", display: "flex", justifyContent: "center", alignItems: "flex-start", border: "1px solid black", backgroundColor: sections.projects ? "black" : "transparent" }} onClick={() => sections.projects ? setSections(prev => ({ ...prev, projects: false })) : setSections(prev => ({ ...prev, projects: true }))}>
                            <div style={{ width: "7px", height: "10px", borderRight: "1px solid white", borderBottom: "1px solid white", transform: "rotate(45deg)", visibility: sections.projects ? "visible" : "hidden" }}></div>
                        </div>
                    </div>

                    {first ? (
                        <div>
                            {/* New items */}
                            <div className="new-item gap-3 d-flex">
                                <div className="input-box  w-100">
                                    <label htmlFor="" className="w-50">
                                        <p className="p4">Project Name</p>
                                        <input
                                            name="projectName"
                                            onChange={handleInfoChange}
                                            type="text"
                                            value={
                                                userData?.projects ? userData?.projects[currentActiveIndex]?.projectName
                                                    ? userData?.projects[currentActiveIndex]?.projectName
                                                    : "" : ""
                                            }
                                        />
                                    </label>
                                    <label htmlFor="" className="w-50">
                                        <p className="p4"> Project Type</p>
                                        <input
                                            name="projectType"
                                            onChange={handleInfoChange}
                                            type="text"
                                            value={
                                                userData?.projects ? userData?.projects[currentActiveIndex]?.projectType
                                                    ? userData?.projects[currentActiveIndex]?.projectType
                                                    : "" : ""
                                            }
                                        />
                                    </label>
                                </div>
                            </div>
                            {/* <div className="new-item mt-3 gap-3 d-flex">
                                <div className="input-box w-100">
                                    <label htmlFor="" className="w-50">
                                        <p className="p4"> City</p>
                                        <input
                                            name="cityName"
                                            onChange={handleInfoChange}
                                            type="text"
                                            value={
                                                userData?.projects ? userData?.projects[currentActiveIndex]?.cityName
                                                    ? userData?.projects[currentActiveIndex]?.cityName
                                                    : "" : ""
                                            }
                                        />
                                    </label>
                                    <label htmlFor="" className="w-50">
                                        <p className="p4"> Country</p>
                                        <input
                                            name="country"
                                            onChange={handleInfoChange}
                                            type="text"
                                            value={
                                                userData?.projects ? userData?.projects[currentActiveIndex]?.country
                                                    ? userData?.projects[currentActiveIndex]?.country
                                                    : "" : ""
                                            }
                                        />
                                    </label>
                                </div>
                            </div> */}
                            <div className="para-z mt-3">
                                <p className="p4">Time Period</p>
                            </div>
                            <div className="new-item time-period mt-2 gap-3 d-flex">
                                <div className="input-box w-100">
                                    <label htmlFor="" className="w-25">
                                        <input
                                            name="startMonth"
                                            onChange={handleInfoChange}
                                            type="text"
                                            placeholder="Month"
                                            value={
                                                userData?.projects ? userData?.projects[currentActiveIndex]?.startMonth
                                                    ? userData?.projects[currentActiveIndex]?.startMonth
                                                    : "" : ""
                                            }
                                        />
                                    </label>
                                    <label htmlFor="" className="w-25">
                                        <input
                                            name="startYear"
                                            onChange={handleInfoChange}
                                            type="text"
                                            placeholder="Year"
                                            value={
                                                userData?.projects ? userData?.projects[currentActiveIndex]?.startYear
                                                    ? userData?.projects[currentActiveIndex]?.startYear
                                                    : "" : ""
                                            }
                                        />
                                    </label>
                                    <label htmlFor="" className="w-25">
                                        <input
                                            name="endMonth"
                                            onChange={handleInfoChange}
                                            type="text"
                                            placeholder="Month"
                                            value={
                                                userData?.projects ? userData?.projects[currentActiveIndex]?.endMonth
                                                    ? userData?.projects[currentActiveIndex]?.endMonth
                                                    : "" : ""
                                            }
                                        />
                                    </label>
                                    <label htmlFor="" className="w-25">
                                        <input
                                            name="endYear"
                                            onChange={handleInfoChange}
                                            type="text"
                                            placeholder="Year"
                                            value={
                                                userData?.projects ? userData?.projects[currentActiveIndex]?.endYear
                                                    ? userData?.projects[currentActiveIndex]?.endYear
                                                    : "" : ""
                                            }
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="currently v-center h-center mt-2">
                                <div
                                    style={{
                                        width: "10px",
                                        height: "10px",
                                        border: "1px solid black",
                                        marginRight: "5px",
                                        backgroundColor: `${userData?.projects ? userData?.projects[currentActiveIndex]?.currentlyWorkingOnThisProject
                                            ? "black"
                                            : "transparent"
                                            : "transparent"}`,
                                    }}
                                    onClick={() => {
                                        let temp = userData.projects == undefined ? [] : userData.projects;
                                        temp[currentActiveIndex] = { ...temp[currentActiveIndex], currentlyWorkingOnThisProject: temp[currentActiveIndex] ? !temp[currentActiveIndex]?.currentlyWorkingOnThisProject : true }
                                        setUserData((prev) => ({ ...prev, projects: temp }))
                                    }
                                    }
                                ></div>
                                <p className="p4">I currently working on this Project</p>
                            </div>

                            {/* Multiple Inputs */}
                            <div className="new-item-1  w-100 gap-4 ">
                                {/* Description */}
                                <div className="input-box d-flex flex-column gap-0 w-100 mt-14">
                                    <div className="input-box w-100 mt-14">
                                        <label htmlFor="" className="w-100">
                                            <p className="p4">Description</p>
                                        </label>
                                    </div>
                                    <div className="w-100 editor-wrapper position-relative">
                                        <ReactQuill
                                            placeholder={`Add information about your project or Just write few things about your project and OUR AI will generate it for you.`}
                                            value={
                                                userData?.projects ? userData?.projects[currentActiveIndex]?.description
                                                    ? userData?.projects[currentActiveIndex]?.description
                                                    : "" : ""
                                            }
                                            onChange={(value) => handleQuilChange(value)}
                                            modules={Projects.modules}
                                            formats={Projects.formats}
                                            height="300px"
                                        />
                                        <div className="writer-btn pointer">
                                            {!loading ? <Button
                                                text="AI Writer"
                                                width="137px"
                                                height="39px"
                                                className="btn-prime-1 btn-primary text-white rounded  "
                                                onClick={handleAIWriter}

                                            />
                                                :
                                                <div style={{ margin: "0", position: "relative", top: "48px", left: "42px" }} class="lds-ring"><div></div><div></div><div></div><div></div></div>}

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* AI Writer button */}
                            <div className="threebtnwrapper">
                                <Button
                                    text="Save"
                                    height="39px"
                                    className="bg-scroll rounded bg-darkPurple w-100"
                                    onClick={handleAddMore}
                                />
                                <Button
                                    text="Close"
                                    height="39px"
                                    className="bg-scroll rounded bg-darkPurple w-100"
                                    onClick={() => handleExp(null)}
                                />
                                <Button
                                    text="Delete"
                                    height="39px"
                                    className="bg-scroll rounded bg-darkPurple w-100"
                                    onClick={() => handleDelete(null)}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="input-box mt-5 ">
                            <label htmlFor="" className="w-100 h-center v-center" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                {totalExperience.map((item, index) => {
                                    return (
                                        userData.projects && userData.projects[index]?.projectName != undefined && userData.projects[index]?.projectName != "" ?
                                            <Button
                                                key={index}
                                                text={`${userData.projects[index]?.projectName}`}
                                                height="39px"
                                                className="bg-scroll rounded bg-darkPurple w-100"
                                                onClick={() => {
                                                    // console.log(index);
                                                    handleExp(index)
                                                }}
                                            /> : null
                                    )
                                })}

                            </label>
                        </div>
                    )}

                    {/* Scroll Button */}
                    {!first ? <div className="input-box mt-5 ">
                        <label htmlFor="" className="w-100 h-center v-center">
                            <Button
                                text="Add more"
                                height="39px"
                                className="bg-scroll rounded bg-darkPurpleDotted w-100"
                                onClick={() => handleExp(totalExperience.length)}
                            />
                        </label>
                    </div>
                        :
                        null}

                </div>
            </div>
        </div>
    );
}

Projects.modules = {
    toolbar: [
        // [{ header: "1" }, { header: "2" }, { font: [] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        // ["link", "image"],
        // ["clean"],
    ],
};

Projects.formats = [
    "header",
    "font",
    "list",
    "bullet",
    "bold",
    "italic",
    "underline",
    "link",
    "image",
];

export default Projects